'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoImages = function IoImages(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.3 10.9c1 0.1 1.8 1 1.7 1.9l-1.1 20.6c-0.1 1-0.9 1.7-1.9 1.6l-25.8-1.2c-1-0.1-1.8-0.8-1.7-1.8l0.1-3.6-1.2 0c-0.9 0.1-1.7-0.5-1.8-1.4l-1.6-18.4c-0.1-0.9 0.5-1.6 1.5-1.7l23.1-1.9c0.9-0.1 1.7 0.5 1.8 1.4l0.4 4.2z m-27.8 0.5c0.1-0.9 0.9-1.7 1.9-1.7l17.1 0.8-0.1-2.4h-0.1v-0.1c-0.1-0.3-0.4-0.6-0.8-0.6l-20.4 1.7c-0.4 0-0.8 0.4-0.8 0.7v0.1l1.3 13.9 1.4-1.9z m26.1 18.4l0.8-15.4v-0.1c0-0.5-0.4-0.8-0.8-0.8l-4.6-0.2-2.2-0.2-16-0.7c-0.4 0-0.8 0.3-0.9 0.7v0.1l-0.2 4.9-0.6 10v0.6l0.5-0.6 7.9-8.5c0.4-0.3 0.7-0.5 1.1-0.5s0.9 0.3 1.1 0.6l3.4 3.8 0.2 0.3c0.2 0.1 0.5 0.3 0.8 0.3s0.4-0.1 0.7-0.3l1.3-0.9c0.4-0.2 0.6-0.3 0.9-0.3s0.7 0.1 0.9 0.4l2.1 2.5z m-5-9.3c-1.5 0-2.7-1.2-2.7-2.8s1.3-2.7 2.7-2.7c1.6 0 2.8 1.3 2.8 2.7s-1.3 2.8-2.8 2.8z' })
        )
    );
};

exports.default = IoImages;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/images.js
// module id = 2285
// module chunks = 0